import { render } from "./adminLayout.vue?vue&type=template&id=5e57d7c1&scoped=true&ts=true"
import script from "./adminLayout.vue?vue&type=script&lang=ts"
export * from "./adminLayout.vue?vue&type=script&lang=ts"

import "./adminLayout.vue?vue&type=style&index=0&id=5e57d7c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e57d7c1"]])

export default __exports__